import { Theme } from '@mui/material';
import { decomposeColor, recomposeColor } from '@mui/material/styles';

export const VIEW_W = 800;
export const CENTER_X = VIEW_W / 2;
export const CENTER_R = 48;
export const SAT_R = 14;
// Inset from edges leaves ~165 SVG units for labels + optional alert triangle
export const LEFT_X = 185;
export const RIGHT_X = 615;
// Breathing room kept between any label and the viewBox edge / its neighbour's slot
export const LABEL_EDGE_PAD = 8;
export const LABEL_SLOT_GUTTER = 6;
export const MIN_VIEW_H = 500;
export const NODE_ROW_H = 70;

export const FOCUS_VIEW_H = 540;
export const FOCUS_MODEL_X = 140;
export const FOCUS_NODE_X = 410;
export const FOCUS_Y = 210;
export const FOCUS_MODEL_R = 48;
export const FOCUS_NODE_R = 48;
export const FOCUS_BOTTOM_Y = 430;

export function getBgColor(theme: Theme): string {
    // Solid (not alpha-transparent) mix of primary into white — this fills SVG "mask" circles
    // (Nodes.tsx, FocusSvg.tsx) that must fully occlude edge lines drawn behind them; a translucent
    // fill would let those lines show through.
    const primary = decomposeColor(theme.palette.primary.main).values;
    const opacity = 0.04;
    const mix = (i: number) => Math.round(255 * (1 - opacity) + primary[i] * opacity);
    const values: [number, number, number] = [mix(0), mix(1), mix(2)];
    return recomposeColor({ type: 'rgb', values });
}

export function calcViewH(leftCount: number, rightCount: number): number {
    return Math.max(MIN_VIEW_H, (Math.max(leftCount, rightCount) + 1) * NODE_ROW_H);
}

export function satY(index: number, count: number, h: number): number {
    return (h / (count + 1)) * (index + 1);
}

export function wrapCenterLabel(text: string, maxChars = 11): string[] {
    const words = text.split(' ');
    const lines: string[] = [];
    let current = '';
    for (const word of words) {
        const candidate = current ? `${current} ${word}` : word;
        if (candidate.length <= maxChars) {
            current = candidate;
        } else {
            if (current) lines.push(current);
            current = word;
        }
    }
    if (current) lines.push(current);
    return lines.slice(0, 3);
}
